export default __webpack_public_path__ + "static/media/sukkur-iba.596721da.jpg";